import { HttpInterceptorFn } from '@angular/common/http';

export const wooCommerceCartTokenInterceptor: HttpInterceptorFn = (
  req,
  next
) => {
  return next(req);
};
